export default {
  id: "vertical-line-plugin",

  renderVerticalLine: function(chartInstance, pointValue) {
    const scale = chartInstance.scales["y-axis-0"];
    const xscale = chartInstance.scales["x-axis-0"];
    let xpos = xscale.getPixelForValue(pointValue);
    const context = chartInstance.chart.ctx;
    context.save();
    // render vertical line
    context.beginPath();
    context.strokeStyle = "grey";
    context.moveTo(xpos, scale.top);
    context.setLineDash([10, 15]);
    context.lineTo(xpos, scale.bottom);
    context.stroke();
    context.restore();
  },

  afterDatasetsDraw: function(chart) {
    if (chart.options.lineAtValue) {
      chart.options.lineAtValue.forEach(pointValue =>
        this.renderVerticalLine(chart, pointValue)
      );
    }
  }
};
